function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { useState } from 'react';
import ImagePlaceholder from '@/ui/ImagePlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
var Image = function Image(_ref) {
    var src = _ref.src, alt = _ref.alt, width = _ref.width, height = _ref.height, ariaLabel = _ref.ariaLabel, className = _ref.className, style = _ref.style, _ref$loading = _ref.loading, loading = _ref$loading === void 0 ? 'lazy' : _ref$loading, placeholderText = _ref.placeholderText;
    var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), hasError = _useState2[0], setHasError = _useState2[1];
    var showPlaceholder = !src || hasError;
    if (showPlaceholder) {
        return /*#__PURE__*/ _jsx(ImagePlaceholder, {
            text: placeholderText || alt
        });
    }
    return /*#__PURE__*/ _jsx("img", {
        src: src,
        alt: alt,
        "aria-label": ariaLabel || alt,
        width: width,
        height: height,
        className: className,
        style: style,
        loading: loading,
        onError: function onError() {
            return setHasError(true);
        }
    });
};
export default Image;
